module.exports = __webpack_public_path__ + "static/img/login.7afad22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login.png
// module id = 6QGk
// module chunks = 1